// Video player
import Plyr from 'plyr';

export default class EagerlyVideoPlayer {
  constructor(root) {
    this.el = root;

    const controls = `
      <div class="video-controls">
        <button type="button" class="video-controls__play" aria-label="play, {title}" data-plyr="play" data-cursor="true"></button>

        <div class="video-controls__control  plyr__controls">
          <div class="video-controls__progress  plyr__progress">
            <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
            <progress class="video-controls__progress__buffer  plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
          </div>

          <button type="button" class="video-controls__fullscreen" data-plyr="fullscreen" aria-label="Open Fullscreen"></button>
        </div>
      </div>
    `;

    const init = () => {
      if (!root) return;

      new Plyr(root, {
        controls,
        loadSprite: false,
        tooltips: { controls: false, seek: false },
        youtube: { noCookie: true },
      });
    };

    init();

    // Don't re-instantiate over an existing one
    if (EagerlyVideoPlayer.instances.has(this.el)) return;

    this.init();
  }

  el;

  static instances = new WeakMap();

  init() {
    // Save a reference to the instance, so we know this DOM node has already been instancied
    EagerlyVideoPlayer.instances.set(this.el, this);
  }

  /**
   * Delete EagerlyVideoPlayer instance from DOM element
   */
  unmount() {
    EagerlyVideoPlayer.instances.delete(this.el);
  }
}
